// extracted by mini-css-extract-plugin
export default {"contents":"jE-z","sectionHeading":"kE-z"};